import { LockOutlined } from "@ant-design/icons";
import { Button, Card, Form, Input, notification, PageHeader } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { AdminService } from "../../services/AdminService";

const MIN_LENGTH = 10;
const MAX_LENGTH = 72;

const ChangePassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const router = useHistory();

  const onFinish = (values) => {
    setLoading(true);
    AdminService.changePassword({
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    })
      .then(() => {
        notification.success({
          message: "Success!",
          description:
            "Your password has been changed. Please log in again with your new password.",
        });
        // Yeni parolayla tekrar girisi zorunlu kil.
        localStorage.clear();
        router.push("/login");
      })
      .catch(() => {
        // Hata bildirimini HttpClient interceptor'u zaten gosteriyor.
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <PageHeader title="Change Password" />
      <Card style={{ maxWidth: 480 }}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
            name="currentPassword"
            label="Current password"
            rules={[
              { required: true, message: "Please enter your current password" },
            ]}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="New password"
            extra={`At least ${MIN_LENGTH} characters, including a letter and a number.`}
            dependencies={["currentPassword"]}
            rules={[
              { required: true, message: "Please enter a new password" },
              {
                min: MIN_LENGTH,
                message: `Password must be at least ${MIN_LENGTH} characters`,
              },
              {
                max: MAX_LENGTH,
                message: `Password must be at most ${MAX_LENGTH} characters`,
              },
              {
                validator: (_, value) =>
                  !value || (/[A-Za-z]/.test(value) && /[0-9]/.test(value))
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error("Password must contain a letter and a number")
                      ),
              },
              ({ getFieldValue }) => ({
                validator: (_, value) =>
                  !value || value !== getFieldValue("currentPassword")
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          "New password must be different from the current one"
                        )
                      ),
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="Confirm new password"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator: (_, value) =>
                  !value || value === getFieldValue("newPassword")
                    ? Promise.resolve()
                    : Promise.reject(new Error("Passwords do not match")),
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            icon={<LockOutlined />}
          >
            Change Password
          </Button>
        </Form>
      </Card>
    </>
  );
};

export default ChangePassword;
